<script>
import TextInput from "@/components/TextInput";
import ErrorMessage from "@/components/ErrorMessage";
import SubmitButton from "@/components/SubmitButton";
import i18n from "../../plugins/i18n";
import { useUserStore } from "../../stores/user";

const statusCodes = {
  400: "views.modals.modify_password.400",
};

export default {
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  components: {
    TextInput,
    ErrorMessage,
    SubmitButton,
  },
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      oldPassword: "",
      password: "",
      passwordConfirm: "",
      errors: [],
    };
  },
  methods: {
    closeMessage(id) {
      Object.keys(this.errors).forEach((key) => {
        if (id === this.errors[key].id) {
          this.errors.splice(key, 1);
        }
      });
    },
    async modify() {
      const { oldPassword, password, passwordConfirm } = this;
      if (password !== passwordConfirm) {
        this.errors.push({
          id: Date.now(),
          message: "views.modals.modify_password.same",
        });
        return;
      }
      const error = await this.userStore.changePassword({
        password,
        oldPassword
      });
      if (error) {
        const {
          status,
          statusText,
          data: { message },
        } = error;
        this.errors.push({
          id: Date.now(),
          status,
          message: statusCodes[status] || message || statusText,
        });
      } else {
        this.errors.push({
          status: 200,
          id: Date.now(),
          message: "views.modals.modify_password.update",
        });
        setTimeout(() => {
          window.location = i18n.global.t("path.mairie");
        }, 1000);
      }
    },
  },
};
</script>

<template>
  <div class="p-8 z-50 bg-white shadow-xl rounded sm:min-w-md sm:max-w-md">
    <header class="text-gray-700 text-xl font-bold">
      <span>{{ $t("views.modals.modify_password.modification") }}</span>
    </header>

    <div v-for="msg in errors" :key="msg.id">
      <ErrorMessage class="mt-2" :value="msg" @input="closeMessage" />
    </div>
    <div class="py-4">
      <p class="text-lightGrey">
        {{ $t("views.modals.modify_password.infos.1") }}
      </p>
      <p class="mt-2 text-lightGrey">
        {{ $t("views.modals.modify_password.infos.2") }}
      </p>
    </div>
    <form data-cy="passwordChangeForm" @submit.prevent="modify">
      <TextInput id="oldPassword" v-model="oldPassword" data-cy="oldPassword"
        :label="$t('views.modals.modify_password.actual')" type="password" class="mb-4" />
      <TextInput id="password" v-model="password" data-cy="password" :label="$t('views.modals.modify_password.new')"
        type="password" class="mb-4" />
      <TextInput id="passwordConfirm" v-model="passwordConfirm" data-cy="passwordConfirm"
        :label="$t('views.modals.modify_password.confirm')" type="password" class="mb-4" />
      <SubmitButton />
    </form>
  </div>
</template>
